import { AudioSettingsContext } from '@/utils/providers/audioSettingsContext/AudioSettingsContext';
import { useContext } from 'react';

export const useAudioSettings = () => {
  const context = useContext(AudioSettingsContext);
  if (!context) {
    throw new Error('useAudioSettings must be used within AudioSettingsProvider');
  }
  return context;
};
